import { render } from "./complaint_detail.vue?vue&type=template&id=15df0f63&scoped=true&ts=true"
import script from "./complaint_detail.vue?vue&type=script&lang=ts"
export * from "./complaint_detail.vue?vue&type=script&lang=ts"

import "./complaint_detail.vue?vue&type=style&index=0&id=15df0f63&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15df0f63"]])

export default __exports__